import React, {useState} from 'react';
import s from '../CreateInvoice.module.css';
import QuantityHandler from '../../../Components/QuantityHandler/QuantityHandler';
import {ProductInDepotType} from '../../../types/ProductSliceTypes';
import {useFormikContext} from 'formik';
import {CreateInvoiceType} from '../../../types/TypesStore';
import {formatWeight} from '../../../assets/utils/utils';

type Props = {
	product: ProductInDepotType | any;
	handleChangeProduct: (
		id: string,
		action: '+' | '-' | 'manual' | 'remove',
		value?: number,
	) => void;
	isEditing?: boolean;
	hideStockColumn?: boolean;
};
const CreateTableRowEl: React.FC<Props> = ({
	product,
	handleChangeProduct,
	isEditing = false,
	hideStockColumn = false,
}) => {
	const {values} = useFormikContext<CreateInvoiceType>();
	const invoiceType = values.type;
	const isIncomeOrPre = invoiceType === 'income' || invoiceType === 'pre-order';
	const isOutcomeOrWriteOff =
		invoiceType === 'outcome' || invoiceType === 'write-off';

	const isDisabledIncome =
		!isEditing && isIncomeOrPre && !product.visible_count;
	const isDisabledOutcome =
		!isEditing && isOutcomeOrWriteOff && !product.visible_count;
	const isDisabled = isDisabledIncome || isDisabledOutcome;

	const nameCellClass = `${s.name} ${isDisabled ? s.disabledText : ''}`;
	const [showDetails, setShowDetails] = useState<boolean>(false);

	const toggleDetails = () => setShowDetails((prev) => !prev);

	return (
		<>
			<div className={`${s.gridRow} ${isDisabled ? s.disabledRow : ''}`}>
				<div className={`${s.cell} ${s.nameCell}`}>
					<div className={s.imageContainer}>
						<img src={product.href ?? ''} alt={product.name} />
					</div>
					<button
						type="button"
						className={nameCellClass + ' ' + s.nameButton}
						onClick={toggleDetails}
					>
						{product.name}
					</button>
				</div>
				{!hideStockColumn && (
					<div className={`${s.cell} ${s.hideOnMobile}`}>
						{product.count_store}
					</div>
				)}
				<div className={`${s.cell} ${s.hideOnMobile}`}>{product.points} Б</div>
				<div className={`${s.cell} ${s.hideOnMobile}`}>{product.money} грн</div>
				<div className={s.cell}>
					{isDisabledIncome ? (
						<div className={s.noQty} title={product.comment || ''}>
							<span>{'немає'}</span>
							<span className={s.infoIcon} />
						</div>
					) : isDisabledOutcome ? (
						<div className={s.noQty}>
							<span>{'немає'}</span>
						</div>
					) : (
						<QuantityHandler
							productId={product.id}
							count={product.buyQuantity ?? 0}
							onChangeCallback={handleChangeProduct}
							maxCount={
								isOutcomeOrWriteOff ? Number(product.count_store) : undefined
							}
							hidePlus={
								isOutcomeOrWriteOff &&
								Number(product.buyQuantity ?? 0) >= Number(product.count_store)
							}
						/>
					)}
				</div>
			</div>
			{showDetails && (
				<div className={s.mobileDetails}>
					<div className={s.mobileDetailsRow}>
						<span>Ціна:</span>
						<span>{product.money} грн</span>
					</div>
					<div className={s.mobileDetailsRow}>
						<span>Бали:</span>
						<span>{product.points}</span>
					</div>
					<div className={s.mobileDetailsRow}>
						<span>Вага:</span>
						<span>{formatWeight(product.weight || 0)} кг</span>
					</div>
					<div className={s.mobileDetailsRow}>
						<span>На складі:</span>
						<span>{product.count_store}</span>
					</div>
					{product.comment ? (
						<div className={s.mobileDetailsComment}>{product.comment}</div>
					) : null}
				</div>
			)}
		</>
	);
};

export default CreateTableRowEl;
